import styled from 'styled-components'

interface Margin {
	margin: string
}

export const MarginBottom = styled.div<Margin>`
	${({ margin }) => margin && `margin-bottom: ${margin}`}
`
